export class RoutePath {

    //Admin Portal Start
    //Login
    static readonly Admin_Login_page: string = '/admin-login';
    static readonly Admin_Dashborad_page: string = '/admin-dashboard';
    static readonly Admin_Login_OTP: string = '/admin-otp';
    static readonly Admin_Login_Switch_tenant: string = '/switch-garage';
    static readonly Admin_Login_Logout: string = '/admin-logout';

    static readonly Admin_ForgetPassword: string = '/admin-forget-password';
    static readonly Admin_ResetPassword: string = '/admin-reset-password';

    static readonly Admin_Profile: string = '/admin-profile';

    static readonly Admin_TenantManage: string = '/garage-manage';

    //Master Data Setup
    static readonly Admin_ServiceTypes: string = '/service-types';
    static readonly Admin_Services: string = '/services';
    static readonly Admin_VehicleModels: string = '/vehicle-models';
    static readonly Admin_Products: string = '/products';
    static readonly Admin_Promotions: string = '/promotions';

    //Subscription
    static readonly Admin_Subscriptions: string = '/subscriptions';
    static readonly Admin_Subscription_new: string = '/subscription-manage';
    static readonly Admin_Subscription_manage: string = '/subscription-manage/:id';

    //Job 
    static readonly Admin_Customers: string = '/customers';
    static readonly Admin_Vehicles: string = '/vehicles';
    static readonly Admin_Job_create: string = '/job-create';
    static readonly Admin_Job_list: string = '/jobs';
    static readonly Admin_Job_edit: string = '/jobs/:id';
    static readonly Admin_Job_invoice_preview: string = '/jobs/:id/invoice-preview';

    //************************************************************************************************************ */
    //Reports
    static readonly Admin_Report_Daily_Sales: string = '/daily-sales-report';
    static readonly Admin_Report_Products: string = '/product-report';
    static readonly Admin_Report_Services: string = '/service-report';
    static readonly Admin_Report_Revenue: string = '/revenue-report';

    //************************************************************************************************************ */
    //Referrer Management
    static readonly Admin_Referrer: string = '/referrers';

}
